export const createThunkName = (prefix: string, name: string) => `${prefix}/${name}`
